import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import siteConfig from '../data/siteConfig.json';
import SafeIcon from '../common/SafeIcon';
import { FiGlobe } from 'react-icons/fi';

const Footer = () => {
  const { lang, t } = useLanguage();

  return (
    <footer className="bg-glass-dark text-slate-300 pt-16 pb-8 border-t border-slate-800">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-6">
              {siteConfig.brand.logoUrl ? (
                <img src={siteConfig.brand.logoUrl} alt={siteConfig.brand.logoAlt} className="w-8 h-8 rounded-md object-cover" />
              ) : (
                <div className="w-8 h-8 bg-glass-blue rounded-md flex items-center justify-center">
                  <SafeIcon icon={FiGlobe} className="text-white text-lg" />
                </div>
              )}
              <h2 className="font-bold text-xl text-white">
                {siteConfig.business.name.replace(' Elite', '')} <span className="text-glass-blue">Elite</span>
              </h2>
            </Link>
            <p className="text-sm leading-relaxed mb-6">
              {t('hero.subtitle')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm">Liens Rapides / Links</h3>
            <ul className="space-y-3">
              <li><Link to="/services" className="hover:text-glass-blue transition-colors">{t('nav.services')}</Link></li>
              <li><Link to="/about" className="hover:text-glass-blue transition-colors">{t('nav.about')}</Link></li>
              <li><Link to="/gallery" className="hover:text-glass-blue transition-colors">{t('nav.gallery')}</Link></li>
              <li><Link to="/contact" className="hover:text-glass-blue transition-colors">{t('nav.contact')}</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-glass-blue transition-colors">{t('common.privacy')}</Link></li>
              <li><Link to="/terms-of-use" className="hover:text-glass-blue transition-colors">{t('common.terms')}</Link></li>
            </ul>
          </div>

          {/* Services Areas */}
          <div>
            <h3 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm">{t('areas.title')}</h3>
            <ul className="space-y-3 text-sm">
              <li>Dorval</li>
              <li>Montréal</li>
              <li>Lachine</li>
              <li>Pointe-Claire</li>
              <li>West Island</li>
              <li>Laval</li>
            </ul>
          </div>

          {/* Contact Details */}
          <div>
            <h3 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm">Contact</h3>
            <ul className="space-y-4">
              <li>
                <span className="text-xs uppercase tracking-widest text-slate-500 block mb-1">Address</span>
                <span className="text-sm">{siteConfig.business.address}</span>
              </li>
              <li>
                <span className="text-xs uppercase tracking-widest text-slate-500 block mb-1">Phone</span>
                <a href={`tel:${siteConfig.business.phoneHref}`} className="text-sm hover:text-white transition-colors">{siteConfig.business.phoneDisplay}</a>
              </li>
              <li>
                <span className="text-xs uppercase tracking-widest text-slate-500 block mb-1">Email</span>
                <a href={`mailto:${siteConfig.business.email}`} className="text-sm hover:text-white transition-colors">{siteConfig.business.email}</a>
              </li>
              <li>
                <span className="text-xs uppercase tracking-widest text-slate-500 block mb-1">Hours</span>
                <span className="text-sm">{siteConfig.business.hours[lang]}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800 text-sm flex flex-col md:flex-row justify-between items-center gap-4">
          <p>&copy; {new Date().getFullYear()} {siteConfig.business.name}. All rights reserved.</p>
          <p className="text-slate-500">Website designed and developed by SixForge</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
